<template>
  <div id="retailer-turn-in-orders" class="fill-height align-start">
    <v-row class="g-container" no-gutters>
      <v-col>
        <h2 class="ma-0 mb-2">{{ $route.meta.title }}</h2>

        <v-row>
          <v-col cols="12">
            <v-card
              class="px-4 mb-3"
              v-for="(card, index) in cards"
              :key="index"
            >
              <template v-if="$vuetifyDisplay.smAndDown">
                <v-row class="align-center">
                  <v-col cols="12">
                    <div class="d-flex align-center">
                      <v-icon class="p-icon">{{ card.icon }}</v-icon>
                      <span class="g-heading-xs g-bold">{{ card.title }}</span>
                      <v-badge
                        v-if="card.actionableItemCount"
                        offset-x="-20"
                        color="orange"
                        :content="card.actionableItemCount"
                      ></v-badge>
                    </div>
                    <v-divider
                      v-if="$vuetifyDisplay.smAndDown"
                      class="mt-2 mb-2"
                      horizontal
                    ></v-divider>
                    <span>{{ card.description }}</span>
                  </v-col>
                  <v-col cols="12">
                    <v-btn
                      class="i-btn-block-primary g-full-width"
                      :to="{ name: card.routeName }"
                      >View</v-btn
                    >
                  </v-col>
                </v-row>
              </template>

              <template v-else>
                <v-row class="align-center">
                  <v-col cols="12" md="9" lg="10">
                    <div class="d-flex align-center">
                      <v-icon class="p-icon">{{ card.icon }}</v-icon>
                      <div>
                        <div class="g-heading-xs g-bold">
                          {{ card.title }}
                          <v-badge
                            v-if="card.actionableItemCount"
                            offset-x="-4"
                            color="orange"
                            :content="card.actionableItemCount"
                          ></v-badge>
                        </div>
                        <span>{{ card.description }}</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="3" lg="2">
                    <v-btn
                      class="i-btn-block-primary g-full-width"
                      :to="{ name: card.routeName }"
                      >View</v-btn
                    >
                  </v-col>
                </v-row>
              </template>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: () => ({}),

  computed: {
    ...mapGetters('retailerInvites', ['actionableConsents']),
    ...mapGetters('tenant', ['isILR']),

    cards() {
      return [
        {
          title: `${this.isILR ? 'Customer' : 'Retailer'} Management for Turn In Orders`,
          description: `Invite & Manage  ${this.isILR ? 'Customers' : 'Retailers'}`,
          icon: 'mdi-truck-outline',
          routeName: 'retailer-management-for-agents',
          actionableItemCount: this.actionableConsents?.length || 0
        },
        {
          title: 'Agent Invites & Management',
          description:
            'Invite & Manage Agents for Turn In Orders / Manage Agent access rules by State',
          icon: 'mdi-account-plus-outline',
          routeName: 'agent-invites-management'
        },
        {
          title: `Approved Agents by ${this.isILR ? 'Customer' : 'Retailer'}`,
          description: `View approved Agents by ${this.isILR ? 'Customer' : 'Retailer'}`,
          icon: 'mdi-face-agent',
          routeName: 'approved-agents-by-retailer'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
#retailer-turn-in-orders {
  .p-icon {
    height: 32px;
    margin: 0px 12px 0px 0px;
    color: $secondary-color;
  }
}

@media only screen and (min-width: 960px) {
  #retailer-turn-in-orders {
    .p-icon {
      margin: 0px 16px 0px 0px;
    }
    .mdi:before {
      font-size: 32px;
    }
  }
}
</style>
